export interface IClientLogger {
    logInfo(message: string): void;
    logWarn(message: string): void;
    logError(message: string): void;
    logDebug(message: string): void;
}

export type ClientLogLevel = "info" | "warn" | "error" | "debug";

export class ClientLogger implements IClientLogger {
    private readonly _level: ClientLogLevel;
    private readonly _logLevels: Record<ClientLogLevel, number> = {
        debug: 0,
        info: 1,
        warn: 2,
        error: 3
    };

    constructor(level: ClientLogLevel) {
        this._level = level;
    }

    private shouldLog(messageLevel: ClientLogLevel): boolean {
        return this._logLevels[messageLevel] >= this._logLevels[this._level];
    }

    logInfo(message: string): void {
        if (this.shouldLog('info')) {
            console.log(`[INFO] ${message}`);
        }
    }

    logWarn(message: string): void {
        if (this.shouldLog('warn')) {
            console.warn(`[WARN] ${message}`);
        }
    }

    logError(message: string): void {
        if (this.shouldLog('error')) {
            console.error(`[ERROR] ${message}`);
        }
    }

    logDebug(message: string): void {
        if (this.shouldLog('debug')) {
            console.log(`[DEBUG] ${message}`);
        }
    }
}
